import React, { useState } from "react";
import "./ToggleSwitch.css";

const ToggleSwitch = ({ isOn, handleToggle, leftLable, rightLable }) => {
  // const [isOn, setIsOn] = useState(true);

  // const handleToggle = () => {
  //   setIsOn((prev) => !prev);
  // };

  return (
    <div className="toggle-container">
      {/* <span>{isOn ? "ON" : "OFF"}</span> */}
      {leftLable && (
        <span style={{ fontSize: 12, fontWeight: "initial" }}>{leftLable}</span>
      )}

      <label className="switch">
        <input type="checkbox" checked={isOn} onChange={handleToggle} />
        <span className="slider"></span>
      </label>
      {rightLable && (
        <span style={{ fontSize: 12, fontWeight: "initial" }}>
          {rightLable}
        </span>
      )}
    </div>
  );
};

export default ToggleSwitch;
